import { Env } from '@moonpig/launchpad-utils'

/*
  nb. don't use this if you intend to conditionally
  import a node module server-side (tree-shaking won't work) -
  instead use "typeof window !== 'undefined'" directly
*/
export const isBrowser = typeof window !== 'undefined'
export const isServer = !isBrowser
export const isLambda = isServer && Boolean(process.env.LAMBDA_TASK_ROOT)
export const isDevServer = isServer && !isLambda

export const getGlobalStyleEnvironment = (): Env => {
  const env = process.env.MNPG_ENVIRONMENT_NAME
  switch (env) {
    case 'dev':
    case 'uat':
    case 'prod':
      return env
    default:
      return 'uat'
  }
}
